module.exports = __webpack_public_path__ + "img/应用一体化.ec65e777.png";